export default __webpack_public_path__ + "static/media/mapping-active.2f848040.svg";